import { useState, useEffect } from 'react'
import { maApiFetch } from '../api/apis'

export function useFetch(url, opts) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(false)
  useEffect(() => {
    setLoading(true)
    maApiFetch(url, opts)
      .then(response => {
        if (response.errors) {
          setHasError(true)
          throw new Error(response.errors)
        } else {
          setData(response)
          setLoading(false)
        }
      })
      .catch(error => {
        setHasError(true)
        throw new Error(error)
      })
  }, [url, opts])
  return { data, loading, hasError }
}
